import { ROUTE_NAMES, USER_ACTIONS, USER_SUBJECTS } from '@/utils/const.js';
const WorkCenters = () => import('./pages/WorkCenters.vue');
const WorkCentersGrid = () => import('./pages/WorkCentersGrid.vue');

const moduleRoutes = [
  {
    path: '/work-centers',
    name: 'WorkCenters',
    component: WorkCenters,
    meta: {
      allowAnonymous: false,
    },
  },
  {
    path: '/work-centers-grid',
    name: 'WorkCentersGrid',
    component: WorkCentersGrid,
    meta: {
      allowAnonymous: false,
      ability: {
        subject: USER_SUBJECTS.WORK_CENTERS_GRIDS,
        action: USER_ACTIONS.READ,
      },
    },
  },
];

export default (router) => {
  for (let route of moduleRoutes) {
    router.addRoute(ROUTE_NAMES.BASE_LAYOUT, route);
  }
};
